var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "S_PreviousArtboard_22",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer%201"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 2.0417 9.9607 C 1.762 10.2508 1.762 10.7215 2.052 11.0203 L 8.8694 17.7879 C 9.1692 18.0681 9.6399 18.0681 9.9387 17.7879 C 10.2288 17.4881 10.2288 17.0183 9.9387 16.7283 L 4.4619 11.3035 L 19.8293 11.3035 C 20.2437 11.3035 20.5793 10.9677 20.5793 10.5535 C 20.5793 10.1393 20.2437 9.8035 19.8293 9.8035 L 4.3418 9.8035 L 9.9231 4.3162 C 10.2131 4.0164 10.2131 3.5467 9.9231 3.2566 C 9.6243 2.9666 9.1536 2.9666 8.8538 3.2566 L 2.0417 9.9607 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.6ac4bf7b9accc79b68725456dadaab41.svg";
export { ForwardRef as ReactComponent };